/**
 * Configuration settings domain types.
 *
 * Labels are lifted verbatim from the Figma Configuration design (node
 * 213:206026). Only the **Email** channel has fields today — WhatsApp and SMS
 * are "Coming Soon" placeholders. No backend endpoint exists yet (the Settings
 * API has no Configuration screen), so the slice runs on an in-memory seed,
 * mirroring how Booking/Payment started — swap in an SSR fetcher when the email
 * configuration endpoint lands.
 */

export type ConfigurationChannel = "email" | "whatsapp" | "sms";

export interface EmailConfig {
  host: string;
  /** SMTP port — kept as a string for the free-text input ("e.g. 456"). */
  port: string;
  address: string;
  /** Optional "from" address. */
  defaultAddress: string;
  password: string;
  // TODO(design/backend): the Figma shows TWO fields both labelled "Password"
  // side by side — intent unclear (confirm vs app-password?). Reproduced
  // faithfully until clarified.
  passwordConfirm: string;
  useSsl: boolean;
  /** Design label is "Email Use TSL" (TLS). */
  useTls: boolean;
}

export interface ConfigurationSettings {
  email: EmailConfig;
}

export function defaultConfigurationSettings(): ConfigurationSettings {
  return {
    email: {
      host: "",
      port: "",
      address: "",
      defaultAddress: "",
      password: "",
      passwordConfirm: "",
      useSsl: false,
      useTls: false,
    },
  };
}
